export default __webpack_public_path__ + "media/images/dividers/green-tear-8c5b207aa6f2567c610622562a985fa1.png";